module.exports = __webpack_public_path__ + "ninja-chrome-192x192.png";